import * as firestore from 'firebase/firestore';
import { PersonalDocument } from '../types/PersonalDocument';

export default {
  toFirestore(personalDocument: PersonalDocument): firestore.DocumentData {
    return personalDocument;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): PersonalDocument {
    return snapshot.data()! as PersonalDocument;
  },
};
